import Dashboard from "./Dashboard";
import { ProductionFilterProvider } from "./ProductionFilterContext";

export default function DashboardModule() {
  return (
    <ProductionFilterProvider>
      <Dashboard />
    </ProductionFilterProvider>
  );
}
